window.dataLayer = window.dataLayer || [];

export default function sendEvent(category, action, label, value) {
    dataLayer.push({event: "GAEvent", eventCategory: category, eventAction: action, eventLabel: label, eventValue: value})
}
